import apiUrl from '../../../constants';
import axios from 'axios';
import {
	Validator
} from 'vee-validate';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'addticket',
	components: {
		vSelect,
		DatePicker,
		VueElementLoading
	},
	data: function() {
		return {
			ticketDetails: false,
			isLoading: false,
			inwardErrors: {},
			listClientData: [],
			listWarehouseData: [],
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			clientList: [],
			warehouseList: [],
			ClientErr: '',
			WarehouseErr: '',
			createdbyEmail: '',
			addinward: {
				client: '',
				warehouse: ''
			},
			helpTopic: '',
			helpTopicData: [],
			ticketSubject: '',
			templateDescription: '',
			templateDescriptionDetailed: '',
			attachmentUrl: '',
			ticketNo: '',
			selectedImageFile: '',
			file: '',
			getClientName: '',
			getWarehouseName: '',
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.createdbyEmail = userdetail.email;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = this.addinward.client = userdetail.clientid;
				this.createdbyEmail = userdetail.email;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.warehouseid = this.addinward.warehouse = userdetail.warehouseid;
				this.createdbyEmail = userdetail.email;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getHelpTopics()
	},
	methods: {
		getHelpTopics() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getHelpTopics',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.status) {
						this.helpTopicData = result.data.data
					}
					this.isLoading = false
				}, error => {
					console.error(error)
				})
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},
		onUploadFile(event) {
			if (document.getElementById('file').value) {
				let formData = new FormData();
				this.selectedImageFile = this.file;
				formData.append('files', this.selectedImageFile);
				formData.append('ticketno', 0);
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'fileUploadOsTicket',
						'data': formData,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(result => {
						if (result.data.Status) {
							this.attachmentUrl = result.data.Data.Key
							document.getElementById('file').value = ''
							this.createOsTicket()
						} else {
							this.$alertify.error(this.$t('ticketsupport.fileNotUploadErr'));
						}
						this.isLoading = false;
					})
			} else {
				this.createOsTicket()
			}
		},
		createTicket() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log("Invalid Form");
					return false;
				} else {
					this.getClientAndWarehouseName(this.addinward.warehouse, this.addinward.client)
					console.log("Valid Form");
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		createOsTicket() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.templateDescriptionDetailed = "Attachment!!!" + this.attachmentUrl + "Attachment!!!," + "Client:" + this.getClientName + "," + "Warehouse:" + this.getWarehouseName + "," + "Description:" + this.templateDescription
			let subjectDetailed = "Client!!!" + this.getClientName + "Client!!!," + "Warehouse!!!" + this.getWarehouseName + "Warehouse!!!," + "Subject!!!" + this.ticketSubject + "Subject!!!"
			this.input = ({
				"useremail": this.createdbyEmail,
				"subject": subjectDetailed,
				"message": this.templateDescriptionDetailed,
				"topicId": this.helpTopic,
			});
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'createTicket',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.status) {
						this.ticketNo = result.data.data.ticketnumer
						this.$alertify.success(result.data.data.message);
						this.$router.push('/ticketlisting');
					} else {
						this.$alertify.error(result.data.data.message ? result.data.data.message : result.data.msg);
					}
					this.isLoading = false
				}, error => {
					console.error(error)
				})
		},
		closeTicket() {
			this.$router.push('/ticketlisting');
		},
		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			if (result.data.data && result.data.data.length > 0) {
		// 				this.listWarehouseData = result.data.data;
		// 				var warehouseListArray = [];
		// 				result.data.data.forEach(function(item) {
		// 					warehouseListArray[item.warehouseid] = item.warehousename;
		// 				});
		// 				this.warehouseList = warehouseListArray;
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			if (result.data.data && result.data.data.length > 0) {
		// 				this.listClientData = result.data.data;
		// 				var clientListArray = [];
		// 				result.data.data.forEach(function(item) {
		// 					clientListArray[item.clientid] = item.clientname;
		// 				});
		// 				this.clientList = clientListArray;
		// 			}
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },
		getClientAndWarehouseName(warehouseid, clientid) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.getClientName = ''
			this.getWarehouseName = ''
			this.isLoading = true
			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: this.client
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAndWarehouseName',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.isLoading = false
					if (result.data.status) {
						this.getClientName = result.data.clientData.clientname
						this.getWarehouseName = result.data.warehouseData.warehousename
						this.onUploadFile()
					}
				}, error => {
					console.error(error);
				});
		},
		// clientSelected() {
		// 	this.clientid = this.addinward.client;
		// 	if (this.clientid) {
		// 		if (!this.warehouseid) {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// },
		// warehouseSelected() {
		// 	this.warehouseid = this.addinward.warehouse;
		// 	if (this.warehouseid) {
		// 		if (!this.clientid) {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
	}
}


// WEBPACK FOOTER //
// ./src/views/components/addticket/addticket.component.js